import { useState } from "react";
import { BadgeCheck, CreditCard } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { sendSol } from "@/hooks/usePhantom";

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

export const SubscriptionCard = ({ sub, refresh }) => {
  const [busy, setBusy] = useState("");
  const pay = async () => {
    try {
      setBusy("Getting price…");
      const { data: q } = await api.post("/subscription/quote");
      setBusy("Approve in Phantom…");
      const signature = await sendSol(q.treasury, q.lamports);
      setBusy("Confirming on-chain…");
      for (let i = 0; i < 15; i++) {
        const { data } = await api.post("/subscription/verify", { quote_id: q.quote_id, signature });
        if (data.status === "confirmed") {
          toast.success(`Subscription active until ${new Date(data.sub_expires).toLocaleDateString()}`);
          setBusy("");
          refresh();
          return;
        }
        await sleep(4000);
      }
      toast.error("Payment not confirmed yet. It will be checked again if you retry with the same transaction.");
    } catch (e) {
      toast.error(errMsg(e, "Payment failed"));
    }
    setBusy("");
  };
  const active = sub.active;
  return (
    <div className={`panel p-5 rise ${active ? "" : "border-[#9945FF]/50"}`} data-testid="subscription-card">
      <div className="flex items-center justify-between">
        <div className="panel-title">Subscription</div>
        {active ? (
          <span className="flex items-center gap-1 text-[10px] font-mono text-[#14F195]" data-testid="sub-status-active"><BadgeCheck className="w-3.5 h-3.5" /> ACTIVE</span>
        ) : (
          <span className="text-[10px] font-mono text-[#F59E0B]" data-testid="sub-status-inactive">INACTIVE</span>
        )}
      </div>
      <div className="mt-3 font-mono">
        <span className="text-2xl font-bold">${sub.price_usd}</span><span className="text-slate-400 text-sm"> / {sub.days} days · paid in SOL</span>
      </div>
      <p className="mt-2 text-xs text-slate-400" data-testid="sub-expiry">
        {active
          ? sub.comp ? "Complimentary access" : `Renews manually · active until ${new Date(sub.expires).toLocaleString()}`
          : "The copy engine is paused for your account until you subscribe."}
      </p>
      {!(sub.comp && !sub.expires) && (
        <button data-testid="subscribe-btn" onClick={pay} disabled={!!busy || !sub.open}
          className="mt-4 w-full flex items-center justify-center gap-2 py-2.5 bg-[#9945FF] text-white text-sm font-semibold hover:bg-[#8a3df0] disabled:opacity-50 active:scale-[0.98] transition-[background-color,transform]">
          <CreditCard className="w-4 h-4" /> {busy || (!sub.open ? "Subscriptions opening soon" : active ? "Add 30 days" : "Subscribe with Phantom")}
        </button>
      )}
    </div>
  );
};
